import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/admin/layout.tsx");
